export default "__VITE_ASSET__Q_I$Q3Hj__"